import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import {Alert as WarningAlert} from '@material-ui/lab';
import PackageSelect from 'ApplicationEntry/components/WorkFlow/ProductsRiders/PackageSelect';
import glterm, * as GLActions from 'ApplicationEntry/ducks/ProductsRiders/glterm';
import {CaseDetails, matchCaseDetailsByType} from 'ApplicationEntry/models/CaseDetails';
import {isSpouse, planList} from 'ApplicationEntry/models/ProductsRiders/GLTERM/GLTERM';
import {InvalidGroupGLTERM, ValidGroupGLTERM} from 'ApplicationEntry/models/ProductsRiders/GLTERM/GroupGLTERM';
import States from 'ApplicationEntry/models/States';
import React, {useEffect, useState, useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from '../../ErrorMessages';
import './../ProductRiders.sass';
import FixedCodeRiderInformation from '../FixedCodeRiderInformation';
import {ValidGroupCaseDetails} from 'ApplicationEntry/models/GroupCaseDetails';
import {getSitusStatefromCaseNumber} from 'ApplicationEntry/ducks/caseDetails';
import application from 'ApplicationEntry/ducks/application';
import { getAccounts } from 'Agent/Accounts/ducks/account';
import { Plan } from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import { matchSalaryDeductionOccupationClassModel, SalaryDeductionOccupationClassInfo, SalaryDeductionOccupationClassModel } from 'ApplicationEntry/models/ProductsRiders/SalaryDeductionOccupationClassModel';
import Alert from 'Shared/components/Alert';
import { Dispatch } from 'redux';
import { cons } from 'fp-ts/lib/Array';

type GLTERMProps = {
  glterm: InvalidGroupGLTERM | ValidGroupGLTERM;
  caseDetails: CaseDetails;
};

const GLTERM = (props: GLTERMProps) => {
  const dispatch = useDispatch();
  const {
    plan,
    occClass,
    cwa,
    calculatedPremium,
    type,
    faceAmt,
    premiumType,
    priInsured,
    spouseInsured,
    replacement,
    riderInformation,
    commission,
    deathBenefit,
    adb,
    adbValue,
    sbVolume,
    premiumWaiver,
    premiumWaiverValue,
    packageName,
    packageList,
    CTPLBR,
    GTLCLTC,
    GTLCLTCE,
    GTLCLTCR,
    GTLCLTCRE
  } = props.glterm;

  const [planBlurred, setBlurPlan] = useState(false);
  const [typeLabel, setTypeLabel] = useState<HTMLLabelElement | null>();
  const [situsLabel, setSitusLabel] = useState<HTMLLabelElement | null>();
  const [insuredLabel, setInsuredLabel] = useState<HTMLLabelElement | null>();
  const [pwdisabled] = React.useState(true);
  let {situsState} = props.caseDetails as ValidGroupCaseDetails;

  const showPlanError = planBlurred && plan.key === 'Empty';

  const [uiOccClass, setUiOccClass] = useState<string>('');
  const onOccClassChange = (value: string) => {
    setUiOccClass(value);
  };

  const computedOccClassValue = useMemo(() => {
    let oV = (occClass.key === 'Loaded' ? occClass.Data.saldOccClassInfo.occClass : '');
    const source =
      uiOccClass ||
      (occClass.key === 'Loaded'
        ? occClass.Data.saldOccClassInfo.occClass
        : '');

    if (!source) return '';

    const values = oV.includes(',') ? oV.split(',') : [oV];
    if (values.length > 1) {
      return values[uiOccClass === 'Smoker' ? 1 : 0];
    } else {
      return oV;
    }
  }, [uiOccClass, occClass, uiOccClass]);

  // useEffect(() => {
  // if (!computedOccClassValue) return;

  // dispatch(GLActions.updateOccClassValue(computedOccClassValue));
  // }, [computedOccClassValue, dispatch]);

  return (
    <div className="product-riders-section__policy-type" id="ul-section">
      <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
        <div className="product-riders-section__policy-type__form__row">
          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <FormControl
                error={showPlanError}
                variant="outlined"
                className="product-riders-section__policy-type__form__row--field"
              >
                <InputLabel
                  ref={setTypeLabel}
                  id="gl-plan-label"
                  className={'product-riders-section__policy-type__form__row--label'}
                >
                  Plan
                </InputLabel>
                <Select
                  labelId="gl-label-plan"
                  labelWidth={typeLabel?.clientWidth}
                  id="gl-plan"
                  value={plan.key === 'Empty' ? '' : plan.value}
                  onBlur={() => setBlurPlan(true)}
                  onChange={e => {
                    const caseNum = matchCaseDetailsByType({
                      Group: groupApp => (groupApp.caseNumber.key === 'Loaded' ? groupApp.caseNumber.Data : (groupApp.caseNumber.key === 'UserAssignedCaseNumber' ? groupApp.caseNumber.value : '')),
                      _: () => '',
                    })(props.caseDetails);
                    const PlanObj: Plan = {};
                    PlanObj.life70Name = 'GLTERM';
                    PlanObj.name = 'GLTERM';
                    dispatch(GLActions.getPackageList(caseNum, e.target.value as string));
                    dispatch(GLActions.changePlan(e.target.value as string));
                    dispatch(GLActions.getOccClass(caseNum, PlanObj));
                    dispatch(GLActions.changeADB(false));
                    dispatch(GLActions.changeWaiver(premiumWaiver));
                    dispatch(GLActions.changeReplacement(false));
                    dispatch(GLActions.changeFaceAmt(''));
                    dispatch(GLActions.getCTPLBR(''));
                    dispatch(GLActions.getGTLCLTC(''));
                    dispatch(GLActions.getGTLCLTCE(''));
                    dispatch(GLActions.getGTLCLTCR(''));
                    dispatch(GLActions.getGTLCLTCRE(''));
                  }}
                  displayEmpty
                >
                  {planList.map((product: {name: string; displayName: string}, index: number) => (
                    <MenuItem value={product.name} key={`ul-product-${product.name}-${index}`}>
                      {product.displayName}
                    </MenuItem>
                  ))}
                </Select>
                {showPlanError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
              </FormControl>
            </Grid>

            {plan.key === 'NonEmpty' ? (
              <>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                    <InputLabel ref={setTypeLabel} id="gl-type-label">
                      Type
                    </InputLabel>
                    <Select
                      labelId="gl-label-type"
                      labelWidth={typeLabel?.clientWidth}
                      id="gl-type"
                      value={type.key === 'Empty' ? '' : type.value}
                      onChange={e => {
                        dispatch(GLActions.changeType(e.target.value as string));
                        if (isSpouse(e.target.value as string)) {
                          dispatch(GLActions.resetSpouseInsured());
                        }
                      }}
                      displayEmpty
                    >
                      <MenuItem value="Employee">Employee</MenuItem>
                      <MenuItem value="Spouse">Spouse</MenuItem>
                      <MenuItem value="Child">Child</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                    <InputLabel
                      ref={setSitusLabel}
                      id="gl-situs-label"
                      className={'product-riders-section__policy-type__form__row--label'}
                    >
                      Situs State
                    </InputLabel>
                    <Select
                      labelId="gl-label-situs"
                      labelWidth={situsLabel?.clientWidth}
                      id="gl-situs"
                      value={situsState.value || props.glterm.situsState.value}
                      onChange={e => {
                        dispatch(GLActions.changeSitusState(e.target.value as string));
                        dispatch(getSitusStatefromCaseNumber(''));
                      }}
                      displayEmpty
                    >
                      {States.map(stateCode => (
                        <MenuItem key={stateCode} value={stateCode}>
                          {stateCode}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="gl-faceAmt"
                    label="Face Amount"
                    variant="outlined"
                    placeholder="Face Amount"
                    type="number"
                    margin="normal"
                    fullWidth
                    className="product-riders-section__policy-type__form__row--field"
                    value={faceAmt.key === 'Empty' ? '' : faceAmt.value}
                    onChange={e => dispatch(GLActions.changeFaceAmt(e.target.value as string))}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                    <InputLabel
                      ref={setInsuredLabel}
                      id="gl-primary-label"
                      className={'product-riders-section__policy-type__form__row--label'}
                    >
                      Primary Insured
                    </InputLabel>
                    <Select
                      labelId="gl-label-primary"
                      labelWidth={insuredLabel?.clientWidth}
                      id="gl-primary"
                      value={priInsured.key === 'Empty' ? '' : priInsured.value}
                      onChange={e => {
                      dispatch(GLActions.changePriInsured(e.target.value as string));
                      onOccClassChange(e.target.value as string);
                      }}
                      displayEmpty
                    >
                      <MenuItem value="">&nbsp;&nbsp;</MenuItem>
                      <MenuItem value="Smoker">Smoker</MenuItem>
                      <MenuItem value="Non Smoker">Non Smoker</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                    <InputLabel
                      ref={setTypeLabel}
                      id="gl-spouse-label"
                      className={'product-riders-section__policy-type__form__row--label'}
                    >
                      Spouse
                    </InputLabel>
                    <Select
                      labelId="gl-label-spouse"
                      labelWidth={typeLabel?.clientWidth}
                      id="gl-spouse"
                      value={spouseInsured.key === 'Empty' ? '' : spouseInsured.value}
                      onChange={e => dispatch(GLActions.changeSpouseInsured(e.target.value as string))}
                      displayEmpty
                      disabled={isSpouse(type.value)}
                    >
                      <MenuItem value="">&nbsp;&nbsp;</MenuItem>
                      <MenuItem value="Smoker">Smoker</MenuItem>
                      <MenuItem value="Non Smoker">Non Smoker</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControl component="fieldset" className="product-riders-section__policy-type__form__row--field">
                    <RadioGroup
                      aria-label="Premium Type"
                      name="premiumType"
                      value={premiumType.value}
                      onChange={e => dispatch(GLActions.changePremiumType(e.target.value as string))}
                    >
                      <FormControlLabel
                        key="Modal"
                        value="Modal"
                        control={<Radio />}
                        label="Modal"
                        className="gl-section__form-radio-button"
                      />
                      <FormControlLabel
                        key="Annual"
                        value="Annual"
                        control={<Radio />}
                        label="Annual"
                        className="gl-section__form-radio-button"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    id="gl-premium"
                    label="Premium"
                    variant="outlined"
                    placeholder="Premium"
                    margin="normal"
                    fullWidth
                    className="product-riders-section__policy-type__form__row--field"
                    value={calculatedPremium.key === 'Empty' ? '' : calculatedPremium.value}
                    onChange={event => {
                      dispatch(GLActions.changePremium(event.target.value as string));
                      dispatch(GLActions.changeCalculatedPremium(event.target.value as string));
                    }}
                    disabled={premiumType.key === 'Empty'}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="gl-cwa"
                    label="CWA"
                    variant="outlined"
                    placeholder="CWA"
                    margin="normal"
                    fullWidth
                    className="product-riders-section__policy-type__form__row--field"
                    value={cwa.key === 'Empty' ? '' : cwa.value}
                    onChange={e => dispatch(GLActions.changeCWA(e.target.value as string))}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                  control={
                    <Checkbox
                    color="secondary"
                    checked={premiumWaiver.valueOf().toString() === 'true'}
                    disabled={(premiumWaiverValue.value === '0' || premiumWaiverValue.value === '2') ? pwdisabled : !pwdisabled}
                    name="checkedB"
                    onChange={event => {
                      dispatch(GLActions.changeWaiver(!premiumWaiver));
                      dispatch(
                      GLActions.changeRiderInformation(event.target.checked ? 1 : Number.NaN, 'GTLCPWP', 4)
                      );
                    }}
                    />
                  }
                  label={<Typography>Premium Waiver</Typography>}
                  className="product-riders-section__policy-type__form__row--field"
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={adb.valueOf().toString() === 'true'}
                        name="checkedB"
                        disabled={adbValue.value === '0' || adbValue.value === '2'}
                        onChange={event => {
                          dispatch(GLActions.changeADB(!adb));
                          dispatch(
                            GLActions.changeRiderInformation(event.target.checked ? 0 : Number.NaN, 'GTLCADB', 5)
                          );
                        }}
                      />
                    }
                    label={<Typography>ADB</Typography>}
                    className="product-riders-section__policy-type__form__row--field"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="gl-sb"
                    label="Volume"
                    variant="outlined"
                    placeholder="Volume"
                    margin="normal"
                    type="number"
                    fullWidth
                    className="product-riders-section__policy-type__form__row--field"
                    value={sbVolume.key === 'Empty' ? '' : sbVolume.value}
                    onChange={e => {
                      dispatch(GLActions.changeSBVolume(e.target.value as string));
                      dispatch(GLActions.changeRiderInformation(Number(e.target.value as string), 'GTLCADB', 5));
                    }}
                    disabled={!adb}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  {matchSalaryDeductionOccupationClassModel({
                    Loading: () => (
                      <TextField
                        label="Occ Class"
                        variant="filled"
                        placeholder="Occ Class"
                        className="iwl-section__text-field"
                        value={''}
                        InputProps={{
                          endAdornment: (
                            <CircularProgress className="case-details-section__loading-policy-number-icon" />
                          ),
                        }}
                      />
                    ),
                    Loaded: occClass => (
                      <TextField
                        id="iwl-occ-class"
                        label="OccClass"
                        variant="filled"
                        placeholder="OccClass"
                        inputProps={{readOnly: true}}
                        margin="normal"
                        fullWidth
                        className="iwl-section__form-text-field"
                        value={computedOccClassValue}
                        />
                    ),
                    Unassigned: () => (
                      <TextField
                        id="iwl-occ-class"
                        label="OccClass"
                        variant="filled"
                        placeholder="OccClass"
                        inputProps={{readOnly: true}}
                        margin="normal"
                        fullWidth
                        className="iwl-section__form-text-field"
                        value={''}
                      />
                    ),
                    SalaryDeductionOccupationClassInfoWarning: message => (
                      <>
                        <TextField
                          id="iwl-occ-class"
                          label="OccClass"
                          variant="filled"
                          placeholder="OccClass"
                          inputProps={{readOnly: true}}
                          margin="normal"
                          fullWidth
                          className="iwl-section__form-text-field"
                          value={''}
                        />
                        <WarningAlert severity="warning" className="case-details-section__reserved-alert">
                          {message}
                        </WarningAlert>
                      </>
                    ),
                    Error: () => (
                      <Alert
                        className="billing-agent-section__policy-number-error-label"
                        message="An error occurred while attempting to retrieve an occupation class."
                      />
                    ),
                  })(occClass)}
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedB"
                        color="secondary"
                        id="glterm-replacement"
                        checked={replacement}
                        onChange={() => dispatch(GLActions.changeReplacement(!replacement))}
                      />
                    }
                    label={
                      <Typography className={'product-riders-section__policy-type__form__row--label'}>
                        Replacement
                      </Typography>
                    }
                    className="product-riders-section__policy-type__form__row--field"
                  />
                  <FormControl
                    component="fieldset"
                    className="product-riders-section__policy-type__form__row--field"
                    disabled={!replacement}
                  >
                    <RadioGroup
                      aria-label="Commission"
                      name="gl-label-commission"
                      value={commission.value}
                      onChange={e => dispatch(GLActions.changeCommission(e.target.value as string))}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <PackageSelect
                    packageName={packageName}
                    packageList={packageList}
                    hidden={true}
                    changePackageAction={GLActions.changePackageName}
                    handlePackageItems={(packageItem: object) => {
                      dispatch(GLActions.changePackageItem(packageItem));
                    }}
                  />
                </Grid>
              </>
            ) : null}
          </Grid>
          {plan.key === 'NonEmpty' ? (
            <>
              <FixedCodeRiderInformation
                riderInformation={riderInformation}
                changeRiderInformationAction={GLActions.changeRiderInformation}
                identifier={'group-glterm'}
                isDisabled={(code: string) => {
                  switch (plan.value) {
                    case 'GLTERM':
                      switch (code) {
                        case 'CTPCTZ':
                            return true;
                        case 'GTLCLTC':
                          if (GTLCLTC.value === '1' || GTLCLTC.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        case 'GTLCLTCE':
                          if (GTLCLTCE.value === '1' || GTLCLTCE.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        case 'GTLCLTCR':
                          if (GTLCLTCR.value === '1' || GTLCLTCR.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        case 'GTLCLTCRE':
                          if (GTLCLTCRE.value === '1' || GTLCLTCRE.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        default:
                          return false;
                      }
                    case 'GIGLTERM':
                      switch (code) {
                        case 'GTLCLTC':
                          if (GTLCLTC.value === '1' || GTLCLTC.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        case 'GTLCLTCE':
                          if (GTLCLTCE.value === '1' || GTLCLTCE.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        case 'GTLCLTCR':
                          if (GTLCLTCR.value === '1' || GTLCLTCR.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        case 'GTLCLTCRE':
                          if (GTLCLTCRE.value === '1' || GTLCLTCRE.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        default:
                          return false;
                      }
                    case 'SGLTERM':
                      switch (code) {
                        case 'CTPCTR':
                            return true;
                        case 'GTLCLTC':
                          if (GTLCLTC.value === '1' || GTLCLTC.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        case 'GTLCLTCE':
                          if (GTLCLTCE.value === '1' || GTLCLTCE.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        case 'GTLCLTCR':
                          if (GTLCLTCR.value === '1' || GTLCLTCR.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        case 'GTLCLTCRE':
                          if (GTLCLTCRE.value === '1' || GTLCLTCRE.value === '0') {
                            return false;
                          } else {
                            return true;
                          }
                        default:
                          return false;
                      }
                    default:
                      return false;
                  }
                }}
              />
              <div className="product-riders-section__policy-type__form__row">
                <p className="product-riders-section__policy-type__form__row--text">
                  <small>
                    <b>
                      <em>
                      Valid Age: CTPFPO 18&ndash;60, CTPLBR 0&ndash;75, CTPCTR/CTPCTZ 18&ndash;65, ADB 18&ndash;55, GTLCLTC/GTLCLTCE/GTLCLTCR/GTLCLTCRE 18&ndash;70
                      </em>
                    </b>
                  </small>
                </p>
              </div>
            </>
          ) : null}
        </div>
      </form>
    </div>
  );
};

export default GLTERM;